import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import type { Response, Audit } from '@/models/api-generated'
import http from '@/services/http'
import { BasicAudit, ForeignInternalAudit, InternalAudit, PermAuditRead } from '@/models/enums-generated'
import { hasPermission } from '@/services/utils'

export default defineStore('audit', () => {
	const activeInternal = ref<Audit[]>([])
	const activeBasic = ref<Audit[]>([])
	const activeForeignInternal = ref<Audit[]>([])
	const old = ref<Audit[]>([])
	const oldSelected = ref<Audit>()

	const active = computed(() => [...activeInternal.value, ...activeBasic.value, ...activeForeignInternal.value])
	const oldWithComments = computed(() => old.value.filter((x) => x.numCommentsTotal))

	async function fetch() {
		if (!hasPermission(PermAuditRead)) return
		activeInternal.value.splice(0, activeInternal.value.length)
		activeBasic.value.splice(0, activeBasic.value.length)
		activeForeignInternal.value.splice(0, activeForeignInternal.value.length)
		old.value.splice(0, old.value.length)

		const { data } = await http.get<Response<Audit[]>>('api/audit/list')
		if (data.data?.length) {
			for (const a of data.data) {
				if (a.isActive) {
					if (a.type === BasicAudit) activeBasic.value.push(a)
					if (a.type === InternalAudit) activeInternal.value.push(a)
					if (a.type === ForeignInternalAudit) activeForeignInternal.value.push(a)
				} else {
					old.value.push(a)
				}
			}

			const params = new URLSearchParams(document.location.search)
			const auditStr = params.get('audit')

			if (auditStr) {
				const id = Number.parseInt(auditStr)
				const selected = old.value.find((x) => x.id === id)
				if (selected) {
					oldSelected.value = selected
				}
			}
		}
	}

	return {
		activeInternal,
		activeBasic,
		activeForeignInternal,
		active,
		old,
		oldWithComments,
		oldSelected,
		fetch,
	}
})
